import { take } from "redux-saga/effects";
import { READ_NEW_MESSAGE } from "../../chat/constants";

export function* readNewMessage(socket) {
  while (true) {
    const {
      payload: { messageId },
    } = yield take(READ_NEW_MESSAGE);

    socket.emit("read-message", { messageId });
  }
}
